/* istanbul ignore file */
/* eslint-disable */

let loaded = false
const BYPASS_CONSENT_COOKIE = 'bypass-cookiefirst-consent'

const LOCAL_MAPPING = {
  'vicampo.de': 'de',
  'vicampo.at': 'at',
  'vicampo.ch': 'ch',
  'vicampo.test': 'de',
  'vicampo-at.test': 'at',
  'vicampo-ch.test': 'ch'
}

const _getDevDomain = () => location.hostname?.split('.').slice(-2).join('.')
const _getTopLevelDomain = () => {
  const levels = location.hostname.split('.')
  return levels[levels.length - 1]
}

const _getCountryCode = () => {
  const devMode = import.meta.env.VITE_APP_DEV_MODE === 'ON'
  if (devMode) {
    const devDomain = _getDevDomain()
    return LOCAL_MAPPING[devDomain] || 'de'
  }
  return _getTopLevelDomain()
}

// consent.js decides by user agent whether to load CookieFirst's legacy bundle,
// and it loads that bundle with document.write. iOS WebViews and in-app browsers
// have no "Safari" token, so they count as legacy; a document.write after load
// replaces the whole document with a blank one (VIP-12450). consent.js is
// therefore loaded as an external async script, where browsers ignore
// document.write, and its banner init is deferred so it can run after the
// legacy verdict is corrected: anything that runs this bundle runs module
// scripts, and <dialog> support is what the modern banner needs.
// __CF_PREVENT_AUTO_BANNER_INIT, CF_CUSTOM_INIT_BANNER and
// __COOKIE_IS_BROWSER_LEGACY are consent.js internals, not documented API
// (checked 2026-09-28), so a missing init hook is reported.
const _initBanner = () => {
  if (typeof window.CF_CUSTOM_INIT_BANNER !== 'function') {
    _reportMissingInitHook()
    return
  }

  if (
    window.__COOKIE_IS_BROWSER_LEGACY &&
    typeof HTMLDialogElement === 'function'
  ) {
    window.__COOKIE_IS_BROWSER_LEGACY = false
  }
  // Initialising the legacy banner from here would document.write
  if (!window.__COOKIE_IS_BROWSER_LEGACY) {
    window.CF_CUSTOM_INIT_BANNER()
  }
}

// Without the hook consent.js has run its own init: the modern banner still
// shows, but legacy-detected WebViews and in-app browsers get none
const _reportMissingInitHook = () => {
  import('@/services/ApiController')
    .then(({ default: ApiController }) =>
      ApiController.logFrontendError(
        new Error('CookieFirst consent.js exposes no CF_CUSTOM_INIT_BANNER'),
        'cookiefirst_init_hook_missing',
        'notice'
      )
    )
    .catch(() => {})
}

export const loadCookiefirst = () => {
  if (
    loaded ||
    import.meta.env.VITE_APP_TRACKING_ENABLED === 'OFF' ||
    document.cookie.includes(BYPASS_CONSENT_COOKIE)
  ) {
    return Promise.resolve()
  }
  loaded = true

  const countryCode = _getCountryCode()
  const envVariable = `VITE_APP_COOKIEFIRST_KEY_${countryCode.toUpperCase()}`
  const apiKey = import.meta.env[envVariable]
  const source = `https://consent.cookiefirst.com/sites/vicampo.${countryCode}-${apiKey}/consent.js`

  window.__CF_PREVENT_AUTO_BANNER_INIT = true

  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.async = true
    script.src = source
    script.onload = () => {
      try {
        _initBanner()
      } catch (e) {
        import.meta.env.VITE_APP_DEV_MODE === 'OFF' &&
          console.error('Failed to init cookiefirst:', e)
      }
      resolve()
    }
    script.onerror = () => {
      import.meta.env.VITE_APP_DEV_MODE === 'OFF' &&
        console.error('Failed to load cookiefirst')
      resolve()
    }
    document.head.appendChild(script)
  })
}
